import { FC } from "react";

import { useUrlParamsToSessionStorage } from "../hooks/useUrlParamsToSessionStorage";

/**
 * URLパラメータを監視してセッションストレージに保存するコンポーネント
 * このコンポーネントは画面に何も表示せず、バックグラウンドでURLパラメータを監視します
 */
export const UrlParamsWatcher: FC = () => {
  // URLパラメータのcouponとtypeをセッションストレージに自動保存
  useUrlParamsToSessionStorage();

  // このコンポーネントは何も表示しない
  return null;
};
